import React, { useMemo, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Loading from 'components/Loading'
import _ from 'lodash'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import { RadiologyFragment } from '../Radiology'
import NoData from '../../../MyHealthContentArea/NoDataAvailableBar'
import FhirEnhancedActions from '@web/stores/FhirEnhanced/Actions'
import {
  microbiologyBinarySearchLoading,
  microbiologyBinary,
  microbiologySearchNextLoading,
  microbiologyBinaryCache,
  microbiologyBinaryPreviewLoading,
  microbiologyBinarySearchError
} from '@web/stores/FhirEnhanced/Select'
import { sortRadiology } from '@web/helpers/sortBy'
import LoadMoreButton from 'components/LoadMoreButton'
import queryParams, { getPageParamsFromUrl } from 'helpers/urlhelper'
import { getCurPatientId } from '@web/stores/Account/Select'
import SthWentWrong from 'containers/MyHealth/components/MyHealthContentArea/SthWentWrong'

const binarySearch = {
  name: 'microbiology',
  request: FhirEnhancedActions.microbiologyBinarySearch,
  preview: FhirEnhancedActions.microbiologyBinaryPreview,
  loading: microbiologyBinarySearchLoading,
  previewLoading: microbiologyBinaryPreviewLoading,
  json: microbiologyBinary,
  cache: microbiologyBinaryCache,
  error: microbiologyBinarySearchError,
  cancelPreview: FhirEnhancedActions.microbiologyBinaryPreviewCancel
}

const Microbiology = ({ name, loading, data, error }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const items = useMemo(() => {
    return _.get(sortRadiology(data), 'entry', [])
  }, [data])

  const dispatch = useDispatch()

  const isMicrobiologyNextLoading = useSelector(microbiologySearchNextLoading)
  const [allDataLoaded, setAllDataLoaded] = useState(false)
  const patientId = useSelector(getCurPatientId)

  const getNextData = () => {
    const hasNext = _.get(data, 'link[1].relation') === 'next'
    if (hasNext) {
      const nextUrl = _.get(data, 'link[1].url', '')
      const params = queryParams(nextUrl)
      const { pageContext, pageDirection } = getPageParamsFromUrl(nextUrl)
      const _count = _.get(params, '_count')
      dispatch(
        FhirEnhancedActions.microbiologySearchNext(
          patientId,
          _count ? `_count=${_count}` : undefined,
          pageContext,
          pageDirection
        )
      )
    } else {
      setAllDataLoaded(true)
    }
  }

  useEffect(() => {
    const hasNext = _.get(data, 'link[1].relation') === 'next'
    setAllDataLoaded(!hasNext)
  }, [data])

  return (
    <div style={styles.container}>
      {loading && _.isEmpty(items) && <Loading />}
      {!_.isEmpty(items) && (
        <RadiologyFragment
          binarySearch={binarySearch}
          items={items}
          lableLeft={'microbiology'}
          needSubtitle
        />
      )}
      {!loading &&
        _.isEmpty(items) &&
        (error ? <SthWentWrong /> : <NoData name={name} />)}
      {!allDataLoaded ? (
        <div style={styles.loadMoreButtonWrapper}>
          <LoadMoreButton
            loading={isMicrobiologyNextLoading}
            onClick={getNextData}
          />
        </div>
      ) : null}
    </div>
  )
}

export default Microbiology
